<template>
    <Breadcrumbs
        :extraData="this.model.Descrizione"
    />
    <section class="Section">
        <div class="Container">
            <div class="Box">
                <div class="SidebarHolder">
                    <!-- Inizio SidebarSx-->
                    <div class="SidebarSx">
                        <CatalogSearch
                            :categoriaExternal="this.idCategory" 
                            :catalogoSelected="this.idCatalog" 
                            :modelSelected="this.idModel"
                            :inScheda="true"
                        />
                    </div>
                    <!-- Fine SidebarSx-->
                    <div class="SidebarDx">
                        <div class="loader" v-show="this.isLoading"></div>
                        <ModelElements
                            v-show="!this.isLoading"
                            :model="this.model"
                        />
                        <div class="WhiteSpace">&nbsp;</div>
                        <div class="Frame">
                            <div class="AvailabilityLegend">
                                <div class="AvailabilityItem InStock">In stock</div>
                                <div class="AvailabilityItem FewPieces">Low stock</div>
                                <div class="AvailabilityItem OutOfStock">Not Available</div>
                            </div>
                            <VariantsTable
                                :idModel = "this.idModel"
                                :idCatalog = "this.idCatalog"
                            />
                        </div>
                        <ShopBox/>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>

import CatalogSearch from "@/components/Catalogsearch.vue";
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import VariantsTable from "@/components/VariantsTable.vue";
import ShopBox from "@/components/ShopBox.vue";
import ModelElements from "@/components/ModelElements";
import ModelsService from "@/services/models.service.js";

export default{
    components: {
        CatalogSearch,
        Breadcrumbs,
        VariantsTable,
        ShopBox,
        ModelElements
    },
    name: "ModelDetail",
    data(){
        return {
            idCatalog: "",
            idCategory: "",
            idModel: "",
            model: {},
            isLoading: true
        }
    },
    watch:{
        userLang: function(newValues){
            if(newValues != null){
                this.getModel(this.$store.getters.getToken, this.idModel);
            }
        }
    },
    computed: {
        totalCart: function(){
            return this.$store.getters.getPrezzoTotale;
        },
        userLang: function(){
            return this.$store.getters.getLingua;
        }
    },
    methods: {
        setData: function(idCatalog, idCategory, idModel){
            this.idCatalog = idCatalog;
            this.idCategory = idCategory;
            this.idModel = idModel;
        },
        getModel(token, idModello){
            this.isLoading = true;
            let tipiAllegato = "";
            let lang = this.$store.getters.getLingua;
            if(lang == "EN"){
                tipiAllegato = "DOC1_ING,MAN_ING,IMG";
            }
            else if(lang == "IT"){
                tipiAllegato = "DOC1_ITA,MAN_ITA,IMG";
            }
            ModelsService.getModelById(token, idModello, tipiAllegato, this.$store.getters.getLingua).then(
                data => {
                    if(!data){
                        this.$router.push("/");
                    }
                    else{
                        this.model = data;
                        this.isLoading = false;
                    }
                }
            );
        }
    },
    beforeRouteUpdate (to, from, next) {
        this.$store.commit("resetCarrelloTmp");
        this.setData(to.params.idCatalog, to.params.idCategory, to.params.idModel);
        this.getModel(this.$store.getters.getToken, this.idModel);
        next();
    }, 
    beforeRouteLeave(to, from, next) { 
        this.$store.commit("resetCarrelloTmp");
        next();
    },
    created: function(){
        this.setData(this.$route.params.idCatalog, this.$route.params.idCategory, this.$route.params.idModel);
        this.getModel(this.$store.getters.getToken, this.idModel);
    } 
}
</script>
